export interface PaginationMetadata {
  total: number;
  cursor: number | null;
}

/**
 * Cursor-based pagination parameters for API requests
 * Matches CursorPaginationParametersRequest from swagger
 */
export interface CursorPaginationParametersRequest<TCursor = number> {
  pageSize: number;
  cursor?: TCursor | null;
}

export class PaginatedResponse<T> {
  items: T[];
  pagination: PaginationMetadata;

  constructor(props: { items: T[]; pagination: PaginationMetadata }) {
    this.items = props.items;
    this.pagination = props.pagination;
  }
}
